import { Page } from '@app/components/page/Page';
import { PageSkeleton } from '@app/components/page/header/skeleton/PageSkeleton';
import { PageLoader } from '@app/components/page/header/skeleton/PageLoader';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { VideoEditionsEditListSkeleton } from '@app/modules/video-editions';
import { Redirect, Route, useParams, useRouteMatch } from 'react-router-dom';
import { ComposeViewHeader } from './components/ComposeViewHeader';
import { ComposePublishView } from './components/publish/ComposePublishView';
import { CompositionVideoEditionsTab } from './components/CompositionVideoEditionsTab';
import { usePreviewComposition } from './hooks/usePreviewComposition';

/**
 * Composition detail: redirects `/compose/:id` to Edits tab; header with Edits and Publish tabs.
 */
export function ComposeViewPage() {
  const { compositionId } = useParams<{ compositionId: string }>();
  const { path } = useRouteMatch();
  const { query, composition, compositionFromNavigation } = usePreviewComposition();

  const htmlTitle = composition?.name ?? compositionFromNavigation?.name;

  return (
    <PageLoader
      skeleton={
        <PageSkeleton breadcrumbs={2} tabs={2}>
          <VideoEditionsEditListSkeleton />
        </PageSkeleton>
      }
      query={query}
    >
      <Page htmlTitle={htmlTitle}>
        <ComposeViewHeader />
        <Page.Content>
          <Route
            exact
            path={path}
            render={() => <Redirect to={composeRouteGenerator.edits(compositionId!)} />}
          />
          <Route path={`${path}/edits`} component={CompositionVideoEditionsTab} />
          <Route path={`${path}/publish`} component={ComposePublishView} />
        </Page.Content>
      </Page>
    </PageLoader>
  );
}
